import $ from 'jquery/src/jquery'
import AmenitiesMap from "../modules/amenities-map";
import SiteHeader from "../modules/site-header";
import Menu from "../modules/menu";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const nodeSelectors = {
        section: '[js-amenities-popup="section"]',
        container: '[js-amenities-popup="container"]',
        close: '[js-amenities-popup="close"]',
        open: '[js-amenities-popup="open"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close()
            }
        })

        $(nodeSelectors.close).on('click', close)
        $(nodeSelectors.open).on('click', open)

        ScrollTrigger.create({
            trigger: document.querySelector(AmenitiesMap().nodeSelectors.container),
            pin: false,
            markers: false,
            start: "15% bottom",
            end: "85% top",
            // scrub: 1,
            invalidateOnRefresh: true,
            onLeave: function() {
                close()
            },
            onLeaveBack: function() {
                close()
            }
        });
    }

    function open() {
        let element = this

        if( !$(this).hasClass('pin--active') ) {
            SiteHeader().hide();
            Menu().hide();
            $(nodeSelectors.open).removeClass('pin--active')
            $(this).addClass('pin--active')
            $(nodeSelectors.section).addClass('popup--active')

            let target = $(this).data('js-amenities-popup--target')
            $(nodeSelectors.container).addClass('popup--hidden')
            $(target).removeClass('popup--hidden')

            // setTimeout(function() {
                // AmenitiesMap().centerContainerByChild(element)
            // }, 200)
        } else {
            close()
        }
    }

    function close() {
        $(nodeSelectors.section).removeClass('popup--active')
        $(nodeSelectors.open).removeClass('pin--active')
        $(nodeSelectors.container).addClass('popup--hidden')
    }

    return Object.freeze({
        init,
    })
}